
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/next/companies/[company-id]/recruitments",
      function () {
        return require("private-next-pages/next/companies/[company-id]/recruitments.tsx");
      }
    ]);
  